import React from 'react';

class HomeFields extends React.Component {
    render(){
        return (<div></div>)
    }
}

export default HomeFields;